import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 78 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M37 20C37 9.50659 45.5066 1 56 1C66.4934 1 75 9.50659 75 20C75 30.4934 66.4934 39 56 39C45.5066 39 37 30.4934 37 20Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M37 20C37 9.50659 45.5066 1 56 1C66.4934 1 75 9.50659 75 20C75 30.4934 66.4934 39 56 39C45.5066 39 37 30.4934 37 20Z",
      stroke: "black",
      strokeWidth: "2"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M60.4526 24.3253C61.5996 24.3382 62.833 24.7176 64.0896 25.6951L60.3754 20.3457C58.2289 17.2559 53.7933 17.2559 51.6467 20.3457L46.3482 27.9752L44.4824 30.6605C47.2683 32.7418 51.1564 32.087 53.1641 29.1983L54.256 27.625C54.256 27.625 54.2587 27.6198 54.2658 27.6122C54.37 27.4625 54.4899 27.3309 54.6168 27.2199C54.6168 27.2175 54.6195 27.2175 54.6195 27.2175C54.7215 27.0345 58.1209 24.2902 60.4526 24.3253Z",
      fill: "url(#paint0_linear_22972_101660)"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M67.5221 30.6344C66.4227 31.4547 65.1515 31.8516 63.8927 31.8516C63.0422 31.8516 62.196 31.671 61.4125 31.3202C60.4172 30.8741 59.5219 30.1492 58.8404 29.1716L57.7658 27.6241C57.6788 27.5002 57.5843 27.3897 57.4823 27.2914C56.6836 26.5174 55.4448 26.4946 54.6191 27.2166C55.4675 26.3245 57.7085 24.2841 60.4523 24.3256C61.5993 24.3384 62.8327 24.7179 64.0893 25.6954C64.092 25.6977 64.092 25.6977 64.0941 25.6977L67.5221 30.6344Z",
      fill: "#009BD1"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      opacity: "0.35",
      d: "M64.0893 25.6949C60.542 24.5911 58.3679 26.324 57.4823 27.2915C56.6836 26.5175 55.4448 26.4947 54.6191 27.2167C55.8207 25.9527 59.8281 22.3776 64.0893 25.6949Z",
      fill: "url(#paint1_linear_22972_101660)"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M56.0033 16.5085C58.0465 16.5085 59.7029 14.7912 59.7029 12.6727C59.7029 10.5543 58.0465 8.83691 56.0033 8.83691C53.9601 8.83691 52.3037 10.5543 52.3037 12.6727C52.3037 14.7912 53.9601 16.5085 56.0033 16.5085Z",
      fill: "url(#paint2_linear_22972_101660)"
    }
  ),
  /* @__PURE__ */ s.jsx("mask", { id: "mask0_22972_101660", maskUnits: "userSpaceOnUse", x: "36", y: "0", width: "40", height: "40", children: /* @__PURE__ */ s.jsx("path", { d: "M76 0H36V40H76V0Z", fill: "white" }) }),
  /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_22972_101660)" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M1 20C1 9.50659 9.50659 1 20 1C30.4934 1 39 9.50659 39 20C39 30.4934 30.4934 39 20 39C9.50659 39 1 30.4934 1 20Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z",
      fill: "#8F8FEF"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "M20.4092 3.16667L20.3857 3.20737L24.5492 24.5002L34.8857 28.25L20.4092 3.16667Z", fill: "white" }),
  /* @__PURE__ */ s.jsx("path", { d: "M19.4725 3.83341L5 28.9167H5.01222L21.5417 14.4385L19.4725 3.83341Z", fill: "white" }),
  /* @__PURE__ */ s.jsx("path", { d: "M34.9691 29.2081L14.5086 21.7916L6.01074 29.2083H34.9691V29.2081Z", fill: "white" }),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint0_linear_22972_101660",
        x1: "44.4825",
        y1: "24.9524",
        x2: "64.0896",
        y2: "24.9524",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#4C9968" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.3342", stopColor: "#2F9A90" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.7781", stopColor: "#0D9BBF" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#009BD1" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint1_linear_22972_101660",
        x1: "62.1418",
        y1: "21.7097",
        x2: "56.6614",
        y2: "29.6699",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", {}),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint2_linear_22972_101660",
        x1: "58.5646",
        y1: "15.4456",
        x2: "53.0362",
        y2: "10.3393",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { stopColor: "#D83547" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.0433", stopColor: "#DC4147" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.1667", stopColor: "#E75C48" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.291", stopColor: "#EF7049" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.4159", stopColor: "#F37C49" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "0.5419", stopColor: "#F58049" }),
          /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#F0C84B" })
        ]
      }
    )
  ] })
] });
export {
  o as G
};
